var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "overflow-y-auto",
      style: { height: "calc(100vh - 4.5rem - 8rem - 3.5rem)" }
    },
    [
      _vm.fetchLoading
        ? _c(
            "div",
            { staticClass: "h-full grid items-center justify-center" },
            [_c("div", { staticClass: "blum-loader" })]
          )
        : _c("div", [
            _c(
              "div",
              {
                staticClass: "sticky z-10 transition-all duration-300",
                class: [_vm.currentForm ? "-top-12" : "-top-14"]
              },
              [
                _c("img", {
                  staticClass: "absolute z-0 h-25 w-auto flex-shrink-0",
                  attrs: { src: "/static/bg-prospect-generate-link.png" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "h-25 py-2 px-6 flex flex-col justify-between"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between" },
                      [
                        _c("BlTextSubtitle2", {
                          staticClass: "text-pure-white",
                          attrs: { text: "Send form to parents" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "cursor-pointer",
                            on: {
                              click: function($event) {
                                _vm.learnMoreOpened = true
                              }
                            }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-pure-white underline",
                              attrs: { text: "Learn more" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.currentForm.id
                      ? _c("BlInputButton", {
                          class: {
                            "pointer-events-none": _vm.prospectStage.is_admitted
                          },
                          attrs: {
                            type: _vm.prospectStage.is_admitted
                              ? "primary"
                              : "outlined",
                            dense: "",
                            label: "Generate link",
                            loading: _vm.generateLoading,
                            disabled: _vm.prospectStage.is_admitted
                          },
                          on: { clicked: _vm.onGenerateLink }
                        })
                      : _c(
                          "div",
                          {
                            staticClass:
                              "py-1 px-3 flex items-center justify-between gap-2 rounded",
                            style: {
                              background: "rgba(255, 255, 255, 0.8)",
                              zIndex: 1
                            }
                          },
                          [
                            _vm.generateLoading
                              ? _c(
                                  "div",
                                  { staticClass: "w-full flex justify-center" },
                                  [_c("div", { staticClass: "blum-loader-xs" })]
                                )
                              : _vm.currentForm.submitted_at
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "h-6 px-2 flex items-center gap-2 rounded-full bg-dark-purple-100"
                                  },
                                  [
                                    _c("BlTextBody3", {
                                      staticClass: "text-pure-white",
                                      attrs: {
                                        text:
                                          "Filled on " +
                                          _vm.displayDate(
                                            _vm.currentForm.submitted_at,
                                            "DD/MM/YYYY [at] HH:mm"
                                          )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlIcon", {
                                      staticClass: "h-4 w-4",
                                      attrs: {
                                        icon: "check-circle",
                                        color: "white"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center gap-2 truncate cursor-pointer",
                                    attrs: {
                                      title:
                                        _vm.origin +
                                        "/prospect-form/" +
                                        _vm.currentForm.slug
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.copyToClipboard(
                                          _vm.origin +
                                            "/prospect-form/" +
                                            _vm.currentForm.slug,
                                          "Prospect Form"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("BlIcon", {
                                      staticClass: "h-5 w-5",
                                      attrs: { icon: "copy" }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      staticClass:
                                        "text-light-purple-400 truncate",
                                      attrs: {
                                        text:
                                          _vm.origin +
                                          "/prospect-form/" +
                                          _vm.currentForm.slug
                                      }
                                    })
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _c("BlInputButton", {
                              class: {
                                "pointer-events-none":
                                  _vm.prospectStage.is_admitted
                              },
                              attrs: {
                                type: "outlined",
                                dense: "",
                                label: "Generate new link",
                                loading: _vm.generateLoading,
                                disabled: _vm.prospectStage.is_admitted
                              },
                              on: { clicked: _vm.onGenerateLink }
                            })
                          ],
                          1
                        )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _vm.prospectInformation
              ? _c(
                  "div",
                  { staticClass: "py-5 px-6 flex flex-col gap-3" },
                  [
                    _c("ChildSection"),
                    _vm._v(" "),
                    _c("FatherSection"),
                    _vm._v(" "),
                    _c("MotherSection"),
                    _vm._v(" "),
                    _c("ApproximateAgeSection"),
                    _vm._v(" "),
                    _c("PregnancyAndBirthSection"),
                    _vm._v(" "),
                    _c("ConsultationRecordsSection"),
                    _vm._v(" "),
                    _c("AdditionalInformationSection", {
                      on: {
                        "after-commit": function($event) {
                          return _vm.$emit("after-commit")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("OtherGuardianSection")
                  ],
                  1
                )
              : _vm._e()
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "fixed w-screen right-0 flex justify-end transition-all duration-500",
          style: {
            top: _vm.learnMoreOpened
              ? "calc(4.5rem + 5rem + 3rem)"
              : "calc(100vh)",
            height: "calc(100vh - 4.5rem - 5rem - 3rem)",
            zIndex: 53
          },
          attrs: { id: "learn-more-information-panel" }
        },
        [
          _c("div", {
            staticClass: "h-full w-screen absolute left-0 top-0 -z-10",
            on: {
              click: function($event) {
                _vm.learnMoreOpened = false
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "h-full w-120 flex-shrink-0 flex flex-col relative z-0"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "relative h-full flex flex-col bg-pure-white overflow-y-auto"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky top-0 z-10 h-12 flex-shrink-0 overflow-hidden"
                    },
                    [
                      _c("img", {
                        staticClass: "absolute z-0 h-25 w-auto flex-shrink-0",
                        attrs: { src: "/static/bg-prospect-generate-link.png" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "h-12 px-6 flex items-center justify-between"
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("BlTextSubtitle2", {
                                staticClass: "text-pure-white",
                                attrs: { text: "What is Send Form to Parents?" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.learnMoreOpened
                            ? _c("BlInputButton", {
                                attrs: {
                                  type: "outlined",
                                  dense: "",
                                  icon: "close"
                                },
                                on: {
                                  clicked: function($event) {
                                    _vm.learnMoreOpened = false
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "py-5 px-6 flex flex-col gap-3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "p-4 flex flex-col gap-3 rounded-2xl bg-slate-200"
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-slate-800",
                                attrs: {
                                  text:
                                    "Use this feature to send a form to parents, enabling them to fill out additional information about their child. Once they complete the form, the information will be automatically added to the client information section."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("BlTextSubtitle3", {
                                staticClass: "text-rose-700",
                                attrs: { text: "Attention: " }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-slate-800",
                                attrs: {
                                  text:
                                    "Once parents have filled the form out, the link will become unavailable. Ensure the form is accurate and complete before distribution. Please note that the link will "
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-slate-800 font-bold",
                                attrs: {
                                  text: "expire 7 days after it is generated, "
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-slate-800",
                                attrs: {
                                  text:
                                    "but you can generate a new link if needed. Admin can always update the information later if necessary."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-slate-800",
                                attrs: {
                                  text:
                                    "To modify the form, please visit the Center Settings."
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "w-full",
                          attrs: {
                            to: "/center/client-acquisition/form",
                            target: "_blank"
                          }
                        },
                        [
                          _c("BlInputButton", {
                            staticClass: "w-full",
                            attrs: {
                              label: "Go to center settings",
                              type: "outlined"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6730903e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6730903e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/prospectPanel/ClientInformationTab.vue
// module id = null
// module chunks = 